import {
  child,
  get,
  getDatabase,
  orderByChild as orderByChildDatabase,
  query,
  ref,
  update as updateFirebaseDatabase
} from 'firebase/database'
import { getApp } from 'firebase/app'

export function reference(url: string) {
  const database = getDatabase(getApp())
  return ref(database, url)
}

export function once(url: string) {
  const database = getDatabase(getApp())
  return get(child(ref(database), url))
}

export function on(url: string) {
  const database = getDatabase(getApp())
  return get(child(ref(database), url))
}

// eslint-disable-next-line no-useless-escape
const replaceAll = (s = '', f = '', r = '') => s.replace(new RegExp(f.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), r)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function update(url: string, value: { [key: string]: any }) {
  return updateFirebaseDatabase(reference(url), JSON.parse(replaceAll(JSON.stringify(value), 'undefined', 'null')))
}

export async function orderByChild(url: string, child2: string) {
  const database = getDatabase(getApp())
  return get(query(ref(database, url), orderByChildDatabase(child2)))
}
